import { useQuery } from '@tanstack/react-query';

import { tokenStore } from '../../shared/api/tokens';
import { getMe, type CurrentUser } from './api';

/**
 * Текущая сессия: профиль из GET /v1/me. Запрос включается только при наличии
 * access-токена; при 401 axios-интерцептор пробует refresh, иначе — редирект в
 * AuthGuard.
 */
export function useSession() {
  const hasToken = Boolean(tokenStore.getAccess());
  const query = useQuery<CurrentUser>({
    queryKey: ['me'],
    queryFn: getMe,
    enabled: hasToken,
    staleTime: 5 * 60_000,
    retry: false,
  });

  return {
    user: query.data ?? null,
    isLoading: hasToken && query.isLoading,
    isError: query.isError,
    hasToken,
  };
}
